import { render, staticRenderFns } from "./OcerizarPedido.vue?vue&type=template&id=5510f702&scoped=true&"
import script from "./OcerizarPedido.vue?vue&type=script&lang=js&"
export * from "./OcerizarPedido.vue?vue&type=script&lang=js&"
import style0 from "./OcerizarPedido.vue?vue&type=style&index=0&id=5510f702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5510f702",
  null
  
)

export default component.exports